import axios from "axios";
import { saveAs } from "file-saver";
import modal from "@/plugins/modal";

const baseURL = process.env.VUE_APP_BASE_API;

function getDownloadHeaders(extra = {}) {
    const auth = sessionStorage.getItem("Authorization");
    return Object.assign({}, auth ? { Authorization: auth } : {}, extra);
}

export default {
    // 兼容：name(data, fileName) 与 name(urlPath, data, fileName, onSuccess)
    name(urlsOrData, dataOrName, nameOrOnSuccess, onSuccess) {
        let urls;
        let data;
        let name;
        let successCb;
        if (typeof urlsOrData === "string") {
            urls = urlsOrData;
            data = dataOrName;
            name = nameOrOnSuccess;
            successCb = onSuccess;
        } else {
            data = urlsOrData;
            name = dataOrName;
            successCb = nameOrOnSuccess;
        }
        modal.loading("正在下载数据，请稍候");
        var url = baseURL + (urls ? urls : "file/commonDownloadFile");
        axios({
            method: "post",
            url,
            data,
            responseType: "blob",
            headers: getDownloadHeaders()
        })
            .then((res) => {
                if (res.data.type !== "application/json") {
                    const blob = new Blob([res.data]);
                    this.saveAs(blob, name);
                    if (typeof successCb === "function") successCb();
                } else {
                    modal.confirm("下载文件出现错误，请联系管理员！");
                }
                modal.closeLoading();
            })
            .catch((r) => {
                modal.confirm("下载文件出现错误，请联系管理员！");
                modal.closeLoading();
            });
    },
    zip(urls, data, name) {
        var url = baseURL + (urls ? urls : "file/commonDownloadFiles");
        modal.loading("正在下载数据，请稍候");
        axios({
            method: "post",
            url,
            data,
            responseType: "blob",
            headers: getDownloadHeaders()
        })
            .then((res) => {
                if (res.data.type !== "application/json") {
                    const blob = new Blob([res.data], { type: "application/zip" });
                    this.saveAs(blob, name);
                } else {
                    modal.confirm("下载文件出现错误，请联系管理员！");
                }
                modal.closeLoading();
            })
            .catch((r) => {
                modal.confirm("下载文件出现错误，请联系管理员！");
                modal.closeLoading();
            });
    },
    saveAs(text, name, opts) {
        saveAs(text, name, opts);
    },
    view(urls, data, name, isNewPage = true) {
        var url = baseURL + (urls ? urls : "file/commonDownloadFile");
        axios({
            method: "post",
            url,
            data,
            responseType: "blob",
            headers: getDownloadHeaders({ Accept: "application/pdf,text/plain,*/*" })
        }).then((res) => {
            const blob = new Blob([res.data], { type: "application/pdf" });
            const url = URL.createObjectURL(blob);
            if (isNewPage) {
                window.open(url, name, "_blank");
            } else {
                return url;
            }
        });
    },
    viewUrl(urls, data, name) {
        return new Promise((resolve, reject) => {
            var url = baseURL + (urls ? urls : "file/commonDownloadFile");
            axios({
                method: "post",
                url,
                data,
                responseType: "blob",
                headers: getDownloadHeaders({ Accept: "application/pdf,text/plain,*/*" })
            })
                .then((res) => {
                    const blob = new Blob([res.data], { type: "application/pdf" });
                    const url = URL.createObjectURL(blob);
                    resolve(url);
                })
                .catch((r) => {
                    reject(r);
                });
        });
    }
};
